import React from "react";
import PropTypes from "prop-types";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import {Edit as EditIcon} from "@material-ui/icons";

export default class GroupListItem extends React.Component {
  countFilteredGroupUsers(permissionGroups, groupID) {
    return permissionGroups.filter(group => group === groupID).length;
  }
  render() {
    const {permissionGroups, invitationGroups, group, disabled, onOpenModal} = this.props;
    const permissionUserCount = this.countFilteredGroupUsers(permissionGroups, group._id);
    const invitationUserCount = this.countFilteredGroupUsers(invitationGroups, group._id);
    const totalUserPermissions = permissionUserCount + invitationUserCount;
    return (
      <ListItem button onClick={() => onOpenModal(group, totalUserPermissions)} disabled={disabled}>
        <ListItemText
          primary={group.name}
          secondary={
            <React.Fragment>
              {permissionUserCount} {permissionUserCount === 1 ? "user" : "users"}, {invitationUserCount}{" "}
              {invitationUserCount === 1 ? "invitation" : "invitations"} with this group
            </React.Fragment>
          }
        />
        {disabled ? null : (
          <ListItemIcon>
            <EditIcon style={{color: "#999"}} />
          </ListItemIcon>
        )}
      </ListItem>
    );
  }
}

GroupListItem.propTypes = {
  permissionGroups: PropTypes.array,
  invitationGroups: PropTypes.array
};

GroupListItem.deafultProps = {
  permissionGroups: [],
  invitationGroups: []
};



// WEBPACK FOOTER //
// ./src/pages/Account/Groups/GroupListItem/index.jsx